// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2208":"77935960ed8e0ca1","2922":"3cd25f6a9f572612","3255":"d9030d4032cdfc19","8010":"5efa1690f337da2c","8467":"a6e78d27df206688"}[chunkId] + ".css";
};